<template>
  <div
    v-if="showPaywall"
    class="shadow bg-white rounded-xl"
    :class="placement === 'article' ? '-mt-20 md:-mx-3 z-20 relative' : 0"
  >
    <div class="px-5 pt-8 pb-10 text-center">
      <PaperLogo :name="indexStore.currentPaper?.Name" />
      <div class="promo-title px-0 md:px-10">
        <div
          v-if="
            userStore.isLoggedIn &&
            !userStore.hasConfirmedWorkEmail &&
            userStore.hasName &&
            userStore.user?.loginType === 'newuser'
          "
        >
          {{ $t('EmailNotConfirmed') }}
        </div>
        <div v-else>
          {{ atsReadMediaName(indexStore.currentPaper?.Name ?? '') }}
        </div>
        <div class="font-light">
          <template
            v-if="
              userStore.isLoggedIn &&
              !userStore.hasConfirmedWorkEmail &&
              userStore.hasName &&
              userStore.user?.loginType === 'newuser'
            "
          >
            {{ $t('activateemail') }}
          </template>
          <template
            v-else-if="
              isSite('altinget_se') && indexStore.currentPaper?.RecordId === 11
            "
          >
            Läs Altinget Infrastruktur och få nyheter, debatt och analyser om
            politikens väg genom rör, kablar och räls. Vi hjälper dig hålla koll
            på besluten, makthavarna och lagstiftningen.
          </template>
          <template v-else>
            <i18n-t
              :keypath="
                $te(`Paywall.${indexStore.currentPaper?.Url}`)
                  ? `Paywall.${indexStore.currentPaper?.Url}`
                  : `Paywall.teaser`
              "
              tag="span"
              scope="global"
            >
              <template #paper>
                {{
                  indexStore.currentPaper?.Name == 'EU/EØS'
                    ? indexStore.currentPaper?.Name
                    : indexStore.currentPaper?.Name?.toLowerCase()
                }}
              </template>
            </i18n-t>
          </template>
        </div>
      </div>
      <transition name="skeleton" mode="out-in">
        <CommonLogin
          v-if="showLogin && !userStore.isLoggedIn"
          key="login"
          v-model:email="email"
          v-model:password="password"
          class="mt-8"
        >
          <div class="mt-2">
            <a
              class="list-label opacity-35 underline cursor-pointer"
              @click="showLogin = false"
            >
              {{ $t('Back') }}
            </a>
          </div>
        </CommonLogin>
        <div v-else key="promt">
          <div class="flex items-center justify-center mt-5">
            <template
              v-if="
                userStore.isLoggedIn &&
                !userStore.hasConfirmedWorkEmail &&
                userStore.hasName &&
                userStore.user?.loginType === 'newuser'
              "
            >
              <CommonSendActivationEmailButton />
            </template>
            <template v-else>
              <CommonButton
                v-if="!userStore.isLoggedIn"
                id="PaywallLogin"
                class="mr-3"
                @click.native="toggleLogin"
              >
                {{ $t('Login') }}
              </CommonButton>
              <CommonButton
                id="PaywallCreateProfile"
                bg="bg-blue"
                text="text-white"
                border="border-none"
                @click="openTrialModal"
              >
                {{ $t('14dayTrial') }}
              </CommonButton>
            </template>
          </div>
          <div v-if="!userStore.isLoggedIn" class="body-xs opacity-50 mt-3">
            {{ $t('readMoreAboutPricesAndTerms') }}
            <NuxtLink class="underline" :to="{ name: 'terms' }">
              {{ $t('Here') }}
            </NuxtLink>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="placement === 'article'">
      <div class="px-5 label-m text-red">
        {{ $t('LastestFrom') }} {{ indexStore.currentPaper?.Name }}
      </div>
      <CommonDivider />
      <ListArticles
        class="px-5 pb-3 md:pb-6 pt-2"
        type="instream"
        :count="3"
        :offset="2"
        show-more
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContentPaper } from '~/typesManual/content_api/paper'

const dataLayer = useDataLayer()

const indexStore = useIndexStore()
const userStore = useUserStore()

withDefaults(defineProps<{ placement?: 'article' | 'main' }>(), {
  placement: 'article',
})

const showLogin = ref(false)
const email = ref('')
const password = ref('')

const showPaywall = computed(() => {
  return (
    indexStore.currentPaper &&
    indexStore.currentPaper.RecordId !== 1 &&
    (!userStore.hasSubscription(indexStore.currentPaper.RecordId) ||
      !userStore.hasConfirmedWorkEmail)
  )
})

const toggleLogin = () => {
  showLogin.value = true
}

if (showPaywall) {
  dataLayer.trackPaywall()
  dataLayer.ecommerce.viewItem({
    item_id: indexStore.currentPaper?.RecordId,
    item_name: indexStore.currentPaper?.Product?.[0]?.Name,
    item_list_id: 'paywall_paper',
  })
}

const trialModalState = useTrialModalState()

function openTrialModal() {
  trialModalState.value.papers = [indexStore.currentPaper] as ContentPaper[]
  trialModalState.value.open = true
}
</script>
